import {PRICE as DEFAULT_PRICE} from '../../../fixtures';

export default ({
  keys,
  merchant,
  server,
  activePrice,
  formattedActivePriceAmount,
}) => `import React, { useState, useEffect } from "react";
import "./App.css";

const ProductDisplay = () => (
  <section>
    {+preview-page}
    <div className="product">
      <img
        src="https://i.imgur.com/EHyR2nP.png"
        alt="The cover of Stubborn Attachments"
      />
      <div className="description">
      <h3>${(activePrice || DEFAULT_PRICE).product.name}</h3>
      <h5>${formattedActivePriceAmount ||
        DEFAULT_PRICE.formattedActivePriceAmount}</h5>
      </div>
    </div>
    {/preview-page}
    {+add-button}
    <form action="/create-checkout-session${
      server === 'php' ? '.php' : ''
    }" method="POST">
      <button type="submit">
        Checkout
      </button>
    </form>
    {/add-button}
  </section>
);

const Message = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
);

export default function App() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    {+back}
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
    {/back}
  }, []);

  return message ? (
    <Message message={message} />
  ) : (
    <ProductDisplay />
  );
}
`;
